<template>
  <div>
    <div class="col-xs-12 col-sm-12 col-lg-8" :class="isDefault ? 'col-md-8' : 'col-md-12'">
      <div
        class="widget-card carousel-position"
        :class="isDefault ? 'headlines-ht' : 'customised-headlines-ht mb-20'"
      >
        <div class="header d-flex align-items-center">
          <img src="/static/images/icons/headline.svg" />
          <h3 class="title fw-500 m-0">Headlines</h3>
          <div class="admin-features align-right p-0" v-if="roleId === 5 || roleId === 7">
            <span
              @click="regulatoryHeadlines.length >= 8 ? '' : openAddPopup()"
              :class="regulatoryHeadlines.length >= 8 ? 'cursor-pointer-disable' : 'cursor-pointer'"
            >
              <img src="/static/images/icons/plus_icon_blue.svg" class="margin-icon" />
              <span class="admin-features-label">Upload New</span>
            </span>
            <el-popover
              v-if="regulatoryHeadlines.length >= 8"
              class="cursor-pointer"
              placement="bottom-end"
              trigger="click"
              @show="infoActive = true"
              @hide="infoActive = false"
              width="350"
            >
              <div class="limit_popover_txt">
                Max 8 main headlines can be added. Please delete and try again
              </div>
              <img
                class="info-img"
                src="/static/images/icons/info_icon.svg"
                v-if="!infoActive"
                slot="reference"
              />
              <img
                class="info-img"
                src="/static/images/icons/info_icon_active.svg"
                v-if="infoActive"
                slot="reference"
              />
            </el-popover>
            <span
              v-if="regulatoryHeadlines.length > 0"
              @click="openDeletePopup()"
              class="cursor-pointer"
            >
              <img src="/static/images/icons/delete_icon.svg" class="margin-icon" />
              <span class="admin-features-label delete">Delete</span>
            </span>
          </div>
        </div>
        <div class="headline-content pl-0 pr-0">
          <div
            id="myCarousel"
            class="carousel text-center carousel-style"
            data-ride="carousel"
            data-interval="3000"
          >
            <div class="carousel-inner item-hover" role="listbox">
              <div
                class="item align-left"
                v-for="(alert, index) in regulatoryHeadlines"
                :key="index"
                :class="{ active: index == 0 }"
              >
                <div>
                  <div class="row mr-0 date-container">
                    <div class="col-xs-12 date-css fw-500 pr-0 align-left">
                      {{ alert.display_date | UTCDate('MMM DD, YYYY') }}
                    </div>
                  </div>
                  <div
                    class="heading text-emergo-dark-blue fw-400"
                    :class="{ 'url-hover': alert.redirection_url }"
                  >
                    <a href="javascript:void(0);" v-if="!alert.redirection_url">
                      <img :src="getImageUrl(alert.image)" class="headlines-img pb-20" />
                      <span>{{ alert.title }}</span>
                    </a>
                    <router-link
                      :to="getPathFromURL(alert.redirection_url)"
                      v-else-if="alert.redirection_url && selfURL(alert.redirection_url)"
                    >
                      <img :src="getImageUrl(alert.image)" class="headlines-img pb-20" />
                      <span>{{ alert.title }}</span>
                    </router-link>
                    <a
                      :href="alert.redirection_url"
                      target="_blank"
                      v-else-if="alert.redirection_url && !selfURL(alert.redirection_url)"
                    >
                      <img :src="getImageUrl(alert.image)" class="headlines-img pb-20" />
                      <span>{{ alert.title }}</span>
                    </a>
                  </div>
                  <p class="headline-details fw-400 word-break" v-html="alert.description"></p>
                </div>
              </div>
            </div>
            <div
              class="carousel-indicators-container d-flex position-relative"
              :class="{
                'justify-content-center': !(roleId === 5 || roleId === 7),
                'justify-space-between': roleId === 5 || roleId === 7
              }"
            >
              <!-- Indicators -->
              <ol class="carousel-indicators">
                <li
                  data-target="#myCarousel"
                  v-for="(alert, index) in regulatoryHeadlines"
                  :data-slide-to="index"
                  :key="index"
                  :class="{ active: index === 0 }"
                ></li>
              </ol>
              <!-- Wrapper for slides -->
              <div v-if="roleId === 5 || roleId === 7">
                <span
                  v-if="regulatoryHeadlines.length > 0"
                  @click="openEditPopup('Main Headline')"
                  class="cursor-pointer"
                  >&nbsp;&nbsp;
                  <span class="admin-features-label see-all-label fw-500">See All </span>
                </span>
              </div>
            </div>
          </div>
          <div class="separator-line p-0"></div>
        </div>
      </div>
    </div>
    <add-popup
      :userId="userId"
      :propId="propId"
      :editObjects="editObj"
      :operations="operationForAdd"
      @reload="getRegulatoryHeadlines()"
      :index="neHeadlineIndex"
      @reloadList="reloadList"
    ></add-popup>
    <list-popup
      :operations="operations"
      :propId="propId"
      @openModalDelete="openModalDeleteForList"
      @onOpenEditPopup="handleOpenEditPopup"
      @closeList="handleCloseListPopup"
      @selectedHeadLinesList="setSelectedHeadLines"
    >
    </list-popup>
    <delete-popup
      :propId="propId"
      :deletewarnInfo="deleteWarningInfo"
      @dashboardPublishDelete="dashboardPublishDelete()"
    >
    </delete-popup>
  </div>
</template>

<script>
import $ from 'jquery';
import moment from 'moment';
import { Popover } from 'element-ui';
import AddPopup from '../../AddRegHeadlinePopup.vue';
import DeletePopup from '../../../UIComponents/DeleteRegHeadlinePopup.vue';

import ListPopup from '../../ListRegHeadlinePopup.vue';
import { getMainHeadlines, deleteHeadline, deleteFeaureHeadline } from '../../../../apis/dashboard';

export default {
  props: {
    userId: { type: Number },
    isDefault: { type: Boolean }
  },
  components: {
    AddPopup,
    DeletePopup,
    ListPopup,
    // BasePopover,
    'el-popover': Popover
  },
  data() {
    return {
      deleteWarningInfo: {
        loaderStatus: false,
        isSelectedList: false,
        title: ''
      },
      selectedHeadLines: [],
      headlineIndex: 0,
      regulatoryHeadlines: [],
      infoActive: false,
      roleId: null,
      propHeadline: '',
      editObj: {},
      operations: {},
      headlines: [],
      operationForAdd: {},
      loaderStatus: false,
      propId: 'headline'
    };
  },
  methods: {
    setSelectedHeadLines(healines) {
      this.selectedHeadLines = [...healines];
    },

    async openModalDeleteForList(title) {
      this.deleteWarningInfo = {
        ...this.deleteWarningInfo,
        title: `${title}(s)`,
        isSelectedList: true
      };
      $(`#modal_delete${this.propId}`).modal({
        backdrop: 'static',
        keyboard: false
      });
    },

    checkHeadLinesResponse(response) {
      if (response.status_code === 200) {
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Regulatory Headline deleted successfully',
          group: 'custom-notification'
        });
        this.deleteWarningInfo = {
          ...this.deleteWarningInfo,
          loaderStatus: false
        };
        $(`#modal_delete${this.propId}`).modal('hide');
        this.getRegulatoryHeadlines();
      } else {
        this.deleteWarningInfo = {
          ...this.deleteWarningInfo,
          loaderStatus: false
        };
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Deletion of record failed',
          group: 'custom-notification'
        });
      }
    },

    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },
    async dashboardPublishDelete() {
      this.deleteWarningInfo = {
        ...this.deleteWarningInfo,
        loaderStatus: true
      };
      const headLinesList = this.deleteWarningInfo.isSelectedList
        ? [...this.selectedHeadLines]
        : [this.propHeadline.id];
      const body = { id: headLinesList };
      let response;
      if (this.operations.type === 'Featured Content' && this.deleteWarningInfo.isSelectedList) {
        response = await deleteFeaureHeadline(body);
      } else {
        response = await deleteHeadline(body);
      }
      this.checkHeadLinesResponse(response);
      if (this.deleteWarningInfo.isSelectedList) {
        this.operations = { ...this.operations };
      }
    },

    getPathFromURL(url) {
      if (this.selfURL(url)) return new URL(url).pathname;
      return '';
    },
    selfURL(url) {
      return url && url.includes(window.location.hostname);
    },
    async getRegulatoryHeadlines() {
      const regulatoryHeadlines = await getMainHeadlines();
      this.regulatoryHeadlines = regulatoryHeadlines.data;
      $('#myCarousel').carousel(0);
    },
    handleOpenEditPopup(record) {
      this.editObj = {};
      // this.editObj = record;
      this.operationForAdd = {
        type: record.type,
        action_type: 'Edit'
      };
      this.$set(this.editObj, 'newProp', record);
      $(`#addPopup${this.propId}`).modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    /**
     * openAddPopup()
     * Open the modal popup
     */
    openAddPopup(type = 'Main Headline') {
      const paramType = type.replace(/ /g, '').toLowerCase();
      this.$router.push(`${this.$route.path}/${paramType}/add`);
    },

    reloadList() {
      this.operations = {
        type: this.editObj.newProp.type,
        action_type: 'Edit'
      };
    },

    openEditPopup(type) {
      const paramType = type.replace(/ /g, '').toLowerCase();
      this.$router.push(`${this.$route.path}/${paramType}`);
    },

    handleCloseListPopup() {
      $(`#list${this.propId}`).modal('hide');
    },
    /**
     * openDeletePopup()
     * Open the modal popup
     */
    openDeletePopup() {
      this.propHeadline = this.regulatoryHeadlines[this.headlineIndex];
      this.deleteWarningInfo = {
        ...this.deleteWarningInfo,
        title: 'headline',
        isSelectedList: false
      };
      $(`#modal_delete${this.propId}`).modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    getImageUrl(filePath, tokenRequired) {
      if (filePath) {
        if (tokenRequired) {
          return `${process.env.VUE_APP_AZURE_BLOB_URL}${filePath}${this.sasToken}`;
        }
        return `${process.env.VUE_APP_AZURE_BLOB_URL}${filePath}`;
      }
      return null;
    }
  },
  computed: {
    /**
     * neHeadlineIndex()
     * Return headline index for new headline
     */
    neHeadlineIndex() {
      let index = 0;
      this.regulatoryHeadlines.forEach((value) => {
        index = index < value.headlines_index ? value.headlines_index : index;
      });
      index += 1;
      return index;
    }
  },
  async created() {
    try {
      this.roleId = JSON.parse(localStorage.getItem('userData')).role_id;
      this.loaderStatus = true;
      await this.getRegulatoryHeadlines();
      this.loaderStatus = false;
    } catch (err) {
      this.loaderStatus = false;
    }
    $('#myCarousel').carousel();
    $('#myCarousel').bind('slid.bs.carousel', () => {
      this.headlineIndex = $('.item.active').index();
    });
  },
  filters: {
    UTCDate(date, format) {
      return date ? moment.utc(date).format(format) : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.widget-card {
  padding: 24px;
  background: $white;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.27);
  border-radius: $radius10;
  .header {
    box-sizing: border-box;
    border-radius: 10px 10px 0px 0px;
    > img {
      width: 32px;
      height: 32px;
    }
    .title {
      font-family: Roboto;
      color: $primary;
      padding-left: 16px;
      font-size: $font-22 !important;
      line-height: 26px !important;
    }
    .admin-features {
      font-size: $font-16;
      line-height: 19px;
      color: $primary;
      flex: auto;

      span {
        &.cursor-pointer-disable {
          cursor: not-allowed;
        }
        .margin-icon {
          margin: 0 9px 0px 25px;
          padding-bottom: 2px;
        }
        .delete {
          color: $deep-thick-danger;
        }
      }

      .limit_popover_txt {
        text-align: left;
        word-break: break-word;
      }
      .info-img {
        height: 18px;
        width: 18px;
        margin-left: 6px;
      }
    }
  }
  .headline-content {
    padding-top: 18px;
    .carousel-inner {
      min-height: 445px;
      .active {
        a {
          color: $primary !important;
        }
      }
      .date-container {
        margin-bottom: 16px;
        .date-css {
          font-size: $font-16;
          line-height: 19px;
          color: rgba(0, 0, 0, 0.7);
        }
      }
      .heading {
        font-size: $font-20;
        line-height: 23px;
        padding-bottom: 16px;
        a {
          cursor: text;
          .headlines-img {
            width: 100%;
            max-height: 250px !important;
          }
        }

        &.url-hover {
          a:hover {
            text-decoration: underline !important;
            cursor: pointer;
          }
        }
      }
      .headline-details {
        font-size: $font-16;
        line-height: 19px;
        text-align: justify;
        color: rgba(0, 0, 0, 0.7);
        position: inherit;
      }
    }
    .carousel-indicators-container {
      bottom: 20px;
      height: 0px;
      .carousel-indicators {
        left: unset;
        position: relative;
        right: 10px;
        top: 0px;
        width: unset;
        margin-left: unset;
        z-index: 1;
        li {
          padding: 5px;
          margin-bottom: 9px;
          margin-top: 9px;
        }
      }

      .see-all-label {
        color: $messenger-blue;
      }
    }
    .separator-line {
      position: relative;
      bottom: 35px;
      border-top: 0.7px solid #bdbdbd;
    }
  }

  &.headlines-ht {
    min-height: 520px !important;
  }

  &.customised-headlines-ht {
    min-height: 550px !important;
  }

  &.carousel-position {
    position: relative;
  }
}
@media screen and (max-width: 767px) {
  .widget-card {
    .header {
      .admin-features {
        font-size: $font-12;

        span {
          &.cursor-pointer:first-child {
            padding-right: 0px;
          }
          .margin-icon {
            margin: 0px;
          }
          .admin-features-label {
            display: none;
            left: 85%;
          }
        }
        .info-img {
          margin-right: 10px;
        }
      }
    }
    .headline-content {
      .carousel-style {
        margin-bottom: 30px !important;
        .carousel-inner {
          .heading {
            a {
              .headlines-img {
                min-height: 180px !important;
              }
            }
          }
        }
        .carousel-indicators-container {
          bottom: -20px;
          height: 0px;
          .carousel-indicators {
            position: relative;
            right: 8px;
            top: 0px;
            left: unset;
            margin-left: unset;
            z-index: 1;
            li {
              margin-top: 5px;
              margin-bottom: 5px;
            }
          }
        }
        .separator-line {
          position: relative;
          bottom: 20px;
          border-top: 0.7px solid #bdbdbd;
        }
      }
    }

    &.headlines-ht {
      min-height: auto !important;
    }
  }
}

@media (max-width: 600px) {
  .widget-card {
    padding-top: 24px;
    padding-bottom: 24px;
    .header {
      min-height: unset;
      .admin-features {
        margin-left: auto;
        display: flex;
        justify-content: space-between;
        width: 60px;
        flex: unset;
      }
    }
    .headline-content {
      .carousel-style {
        .carousel-indicators-container {
          bottom: -13px;
        }
      }
    }
  }
}

@media (min-width: 992px) and (max-width: 1200px) {
  .date-title {
    text-align: right;
    margin-left: 10px;
    padding-right: 0;
  }
}
@media (min-width: 1201px) and (max-width: 1400px) {
  .date-css {
    font-size: $font-14 !important;
  }
}
</style>
